import { Flex } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PersonalityReportLayerSubMenuItem from './PersonalityReportLayerSubMenuItem';

interface IPersonalityReportLayerPersonalitySubMenu {
  graphs: { id: string; tradKey: string }[];
  nbOfItem: number;
  activeTitle: string;
}

export const PersonalityReportLayerPersonalitySubMenu = ({
  graphs,
  nbOfItem,
  activeTitle,
}: IPersonalityReportLayerPersonalitySubMenu) => {
  const { t } = useTranslation();

  return (
    <>
      {graphs.map((graph, index) => {
        return (
          <Flex key={index} data-test={`left-menu-item-${index}`}>
            <PersonalityReportLayerSubMenuItem
              activeTitle={activeTitle}
              hash={graph.id}
              index={index}
              nbOfItem={nbOfItem}
              title={t(`personalityReport.personality.${graph.tradKey}`)}
            />
          </Flex>
        );
      })}
    </>
  );
};
